const enum ConfirmationModalType {
  DISCARD_PICKS_CHANGES = 'DISCARD_PICKS_CHANGES',
  INCOMPLETE_PICKS_SAVE = 'INCOMPLETE_PICKS_SAVE',
  SPREAD_NOT_SET = 'SPREAD_NOT_SET',
  MISSING_BEST_PICK_SAVE = 'MISSING_BEST_PICK_SAVE',
  WITHDRAW_ENTRY = 'WITHDRAW_ENTRY',
  WITHDRAW_EO_ENTRY = 'WITHDRAW_EO_ENTRY',
  CLEAR_ALL_PICKS = 'CLEAR_ALL_PICKS',
  MAX_PICKS_FOR_SLATE_REACHED = 'MAX_PICKS_FOR_SLATE_REACHED',
  CANCEL_GROUP = 'CANCEL_GROUP',
  CANCEL_PENDING = 'CANCEL_PENDING',
}

type ConfirmationModalPayload = {
  isOnConfirmLoading?: boolean;
  type?: ConfirmationModalType;
  onClose?: () => void;
  onCancel?: () => void;
  onConfirm?: () => void;
};

type ConfirmationModalContextValue = {
  isOpen: boolean;
  payload: ConfirmationModalPayload;
  setIsOpen: (
    props: { isOpen: false } | { isOpen: true; payload: ConfirmationModalPayload }
  ) => void;
};

export type { ConfirmationModalContextValue, ConfirmationModalPayload };

export { ConfirmationModalType };
